export const EMPLOYEE_REPORTING_SCOPE = {
  DIRECT: 'direct', // only my direct reports
  HIERARCHY: 'hierarchy', // my whole reporting tree
  ALL: 'all', // no restriction
};

export const getScopeColor = (scope) => {
  switch (scope) {
    case EMPLOYEE_REPORTING_SCOPE.DIRECT:
      return '#DBEAFE';
    case EMPLOYEE_REPORTING_SCOPE.HIERARCHY:
      return '#E0E7FF';
    case EMPLOYEE_REPORTING_SCOPE.ALL:
      return '#F3E8FF';
    default:
      return '#E5E7EB';
  }
};

export const getScopeTextColor = (scope) => {
  switch (scope) {
    case EMPLOYEE_REPORTING_SCOPE.DIRECT:
      return '#1E40AF';
    case EMPLOYEE_REPORTING_SCOPE.HIERARCHY:
      return '#4338CA';
    case EMPLOYEE_REPORTING_SCOPE.ALL:
      return '#6B21A8';
    default:
      return '#374151';
  }
};

export const getScopeText = (scope) => {
  switch (scope) {
    case EMPLOYEE_REPORTING_SCOPE.DIRECT:
      return 'Direct Reports';
    case EMPLOYEE_REPORTING_SCOPE.HIERARCHY:
      return 'My Hierarchy';
    case EMPLOYEE_REPORTING_SCOPE.ALL:
      return 'All Individuals';
    default:
      return scope;
  }
};